import styled from "styled-components";
import {FormButton, FormButtonCancel} from "../Form";

export const Head = styled.div`
  position: relative;

  & > div {
    margin-bottom: 24px;
  }

  & .close {
    position: absolute;
    top: -12px;
    right: 0;
  }

  @media screen and (max-width: 1024px) {
    & > div {
      margin-bottom: 24px;
    }

    & .close {
      width: 26px;
      height: 26px;
      top: 0px;
      right: 0;
    }
  }
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 25px;
  line-height: 30px;
  text-align: center;
  color: #F12E11;
  margin-bottom: 12px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 12px;
  @media screen and (max-width: 1024px) {
    & {
      display: block;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 24px;
  margin-top: 24px;
`

export const FormButton2 = styled(FormButton)`
  @media screen and (max-width: 1024px) {
    & {
      width: 155px;
      height: 43px;
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      min-width: auto;
    }
  }
`;


export const OtpTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #4F4F4F;
  margin-bottom: 12px;
  margin-top: 36px;
`;
export const OtpDesc = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #535353;
  margin-bottom: 32px;
`;
